import {
  Button,
  Div,
  FinancesSaasPaymentEntity,
  formatAmount,
  H3,
  ModalPortal,
  NumberType,
  P,
} from '@vgrubs/components';

type Props = {
  /** The payment to retry; null keeps it shut. */
  payment: FinancesSaasPaymentEntity | null;
  busy: boolean;
  onClose: () => void;
  onConfirm: () => Promise<boolean>;
};

/** A retry debits the owner's bank account again, so it is confirmed first. */
export const SaasRetryModal = ({
  payment,
  busy,
  onClose,
  onConfirm,
}: Props) => (
  <ModalPortal
    isOpen={!!payment}
    closeModal={onClose}
    logo={false}
    exitButton={false}
    // Above the Monthly Saas modal it opens from.
    zIndex={140}
  >
    {payment && (
      <>
        <H3 $m="10px" $center>
          Retry payment
        </H3>
        <P $mb="24" $center>
          The {formatAmount(payment.amount, NumberType.USD)} SaaS payment of{' '}
          {payment.locationName} is sent to the owner&apos;s bank again. It
          takes 3-5 business days to clear.
        </P>
        <Div $flex $gap="16px">
          <Button
            $selected
            $w="100%"
            $loading={busy}
            disabled={busy}
            onClick={async () => {
              if (await onConfirm()) onClose();
            }}
          >
            Retry
          </Button>
          <Button $selected $gray $w="100%" onClick={onClose}>
            Cancel
          </Button>
        </Div>
      </>
    )}
  </ModalPortal>
);
